<template>
  <div class="flex-row-nowrap-start-center-center ec-button-container" @mouseover="state.hover = true"
    @mouseleave="state.hover = false">
    <ec-icon :name="icon" :size="iconSize" :color="iconColor" :highlightColor="iconHilightColor"
      :highlight="state.hover"></ec-icon>
    <div v-if="!iconButton" style="width:4px;height:1px;"></div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {
  reactive,
  computed
} from "vue";

const props = withDefaults(defineProps<{
  iconButton?: boolean
  icon?: string,
  iconSize?: number
  iconColor?: string
  iconHilightColor?: string
}>(), {
  iconSize: 16,
  iconColor: "#505050",
  iconHilightColor: "#2593f2",
  iconButton: false
})

const state = reactive({
  hover: false
})

</script>
<style scoped>
.ec-button-container {
  background-color: #fefefe;
  cursor: pointer;
  color: #fff;
  text-align: center;
  min-height: 34px;
  padding-left: 8px;
  padding-right: 8px;
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;
  border-color: #e0e0e0;
}

.ec-button-container:hover {
  border-color: #2593f2;
}
</style>
